









































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import ArrowLeftIcon from '../icons/ArrowLeftIcon.vue';
import ArrowRightIcon from '../icons/ArrowRightIcon.vue';
import SelectionField from '../common/inputs/SelectionField.vue';
import { CommonModule } from '@/store/modules/common';

@Component({
  components: {
    ArrowLeftIcon,
    ArrowRightIcon,
    SelectionField
  }
})
export default class SearchPagination extends Vue {
  @Prop(Number) page!: number;
  @Prop(Number) pageTotal!: number;
  @Prop(Number) size!: number;
  sizes: Array<{ text: string; value: number }> = Array.from([10, 20, 50], (value, index) => ({
    value,
    text: value.toString()
  }));

  @Emit()
  onPageChange(page: number) {
    return page;
  }

  get pageSize() {
    return CommonModule.page;
  }

  mounted() {
    if (CommonModule.page === null) {
      this.onSizeChange(20);
    }
  }

  @Emit()
  onSizeChange(size: number) {
    CommonModule.updatePage(size);
    return size;
  }

  pageIsActive(page: number) {
    return page === this.page;
  }

  get pages(): number[] {
    if (!this.pageTotal) {
      return [];
    }
    return Array.from(new Array(this.pageTotal), (_, index) => index);
  }

  prev() {
    if (this.page > 0) {
      this.onPageChange(this.page - 1);
    }
  }

  next() {
    if (this.page < this.pageTotal) {
      this.onPageChange(this.page + 1);
    }
  }
}
